// extracted by css-extract-rspack-plugin
export default {"container":"container-BbYLNM"};// extracted by css-extract-rspack-plugin
export default {"container":"container-BbYLNM"};